<template></template>

<script>
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default {
  setup() {
    const router = useRouter();
    const store = useStore();

    store.dispatch("signout");

    router.push({ name: "signin" });
  },
};
</script>

<style>
</style>